<template>
  <div class="card_offer card_about_us">
    <div class="card_about_us__generic_title">
      <p>Sobre Nosotros</p>
    </div>
    <div
      class="card_about_us__background"
      :style="{backgroundImage: url ? 'url('+ getImageServer() + url +')' : 'url(@/assets/img/img-defecto.svg)'}">
    </div>
    <div
      class="card_about_us__principal_container"
      :style="{backgroundColor: getCompany()['personalize']['colors']['principal']}">
      <div class="card_about_us__principal_container--title">
        {{company_info.attributes.title}}
      </div>
      <p class="card_about_us__principal_container--text" >
        {{company_info.attributes.text}}
      </p>
    </div>
    <div class="card_offer__body card_about_us__body">
      <div class="card_about_us__principal_container--section">
        <p class="card_about_us__principal_container--title">Misión</p>
        <p
          class="card_about_us__principal_container--text"
        >
          {{company_info.attributes.mission}}
        </p>
      </div>
      <div class="card_about_us__principal_container--section">
        <p class="card_about_us__principal_container--title">Visión</p>
        <p
          class="card_about_us__principal_container--text">
          {{company_info.attributes.vision}}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    company_info: Object,
    url: String
  },
}
</script>
<style scoped>
  .card_offer__body--title{
    height: 120px;
    background: #EFF3F7!important;
    border-radius: 10px;
    padding: 10px;
  }
  .card_offer__body--text{
    background: #EFF3F7 !important;
    border-radius: 10px;
    padding: 10px;
  }
  .classes_quantity{
    width: 40px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/client_information/PreviewAboutUs.vue